import React from "react";
import { Modal, Table, Typography, Button } from "antd";

const { Title, Paragraph, Text } = Typography;

const SEOComparisonModal = ({ visible, onClose }) => {
	const columns = [
		{
			title: "Feature",
			dataIndex: "feature",
			key: "feature",
			width: 200,
			render: (text) => <Text strong>{text}</Text>,
		},
		{
			title: "Product Description",
			dataIndex: "productDescription",
			key: "productDescription",
		},
		{
			title: "Meta Description",
			dataIndex: "metaDescription",
			key: "metaDescription",
		},
	];

	const data = [
		{
			key: "1",
			feature: "Purpose",
			productDescription: "Provides detailed information about the product.",
			metaDescription: "Summarizes the product for search engines.",
		},
		{
			key: "2",
			feature: "Audience",
			productDescription: "Customers visiting the product page.",
			metaDescription: "Search engine users viewing search results.",
		},
		{
			key: "3",
			feature: "Length",
			productDescription: "Can be long, usually 100+ words.",
			metaDescription: "Short, ideally 150-160 characters.",
		},
		{
			key: "4",
			feature: "SEO Impact",
			productDescription: "Helps with on-page SEO and conversions.",
			metaDescription:
				"Helps improve click-through rates (CTR) in search results.",
		},
		{
			key: "5",
			feature: "Keyword Usage",
			productDescription: "Natural placement, persuasive copywriting.",
			metaDescription: "Strategic placement for better ranking.",
		},
		{
			key: "6",
			feature: "Visibility",
			productDescription: "Visible on the product page.",
			metaDescription: "Appears in Google search results under the page title.",
		},
		{
			key: "7",
			feature: "Tone",
			productDescription: "Detailed, engaging, persuasive.",
			metaDescription: "Concise, compelling, action-driven.",
		},
	];

	return (
		<Modal
			title="Difference Between Product Description & Meta Description"
			visible={visible}
			onCancel={onClose}
			footer={[
				<Button key="close" onClick={onClose}>
					Close
				</Button>,
			]}
			width={800}
		>
			<Table columns={columns} dataSource={data} pagination={false} bordered />
			<Title level={4} style={{ marginTop: 16 }}>
				Example
			</Title>
			<Paragraph>
				<Text strong>Product Description:</Text> "This stylish leather backpack
				is crafted from premium full-grain leather, offering durability and
				elegance. With multiple compartments, it's perfect for work, travel, or
				daily use. The ergonomic design ensures comfort even during long hours
				of wear."
			</Paragraph>
			<Paragraph>
				<Text strong>Meta Description:</Text> "Premium leather backpack with
				spacious compartments. Ideal for work & travel. Shop now!"
			</Paragraph>
		</Modal>
	);
};

export default SEOComparisonModal;
